import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './app';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import './assets/css/uds-fonts.css';
import './assets/css/style.css';
import './assets/css/footer.css';
import './assets/css/main.css';
import './assets/css/header.css';
import './assets/css/menu.css';
import './assets/css/upload.css';
import './assets/css/radio.css';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
